import { DIST_URL } from 'constants/asset-urls';

// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = DIST_URL;
